// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @utilities
const { toCamelCase } = require('utilities/stringHelper');
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { searchAssociatedAccountId } = require('utilities/currentAccountsHelper');

// @constants
const { PERIODICITY } = require('constants/cardPeriodicLoads');
const { EURO_TEXT, DATE_FORMAT_ES }= require('constants/index');


const DeletePeriodicLoadSuccessStep = props => {
    const { immCard, immAccounts, periodicLoadData } = props;
    const cardAlias = immCard.getIn(['alias','current']);
    const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
    const linkToPeriodicLoads = `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToPeriodicLoads
    };
    const accountNumber = periodicLoadData.get('accountNumber');
    const accountObject = immAccounts.getIn(['byId', searchAssociatedAccountId(accountNumber, immAccounts)]);
    const startDate = DateHelper.customFormat(
        periodicLoadData.get('startDate'),
        DATE_FORMAT_ES
    );
    const endDate = DateHelper.customFormat(
        periodicLoadData.get('endDate'),
        DATE_FORMAT_ES
    );
    const originAccountAlias = accountObject.get('alias') || toCamelCase(accountObject.get('accountType'));
    const originAccountText = `${originAccountAlias} ...${accountObject.get('iban').substr(-4)}`;
    const currency = formatCurrency(EURO_TEXT);
    const amount = getFormattedString({ amount: periodicLoadData.get('transferAmount'), currency });
    const scheduleType = periodicLoadData.get('scheduleType');
    let list = [
        {
            key: originAccountText,
            title: formatText('cardCharge-accounts')
        },
        {
            key: amount,
            title: formatText('transferSuccessful-import')
        },
        {
            key: startDate,
            title: formatText('cardCharge-startDate')
        },
        {
            key: endDate,
            title: formatText('cardCharge-endDate')
        },
        {
            key: formatText(PERIODICITY[scheduleType]),
            title: formatText('transferSummary-step2Periodicity')
        }
    ];

    const listData = list.map((data, index) => {
        const extraClassName = (data.title.replace(/\s/g, '-')).toLowerCase();
        if(data.key){
            return(
                <OKInformativeListItem
                    bodyText={data.key}
                    bodyWordBreak={false}
                    key={index}
                    title={data.title}
                    className={`list-item-${extraClassName}`}
                />
            );
        }
    });

    let successTitle;
    if (immCard.get('isOpenYoung')) {
        successTitle = formatText('deletePeriodicLoadsSuccess-openYoungTitle');
    } else {
        successTitle = formatText('deletePeriodicLoadsSuccess-eCardTitle');
    }

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-1 col-lg-10">
            <WizardSuccess successMessage={successTitle} mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-6">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6">
                        <OKInformativeList columns={2}>
                            {listData}
                        </OKInformativeList>
                    </div>
                </section>
            </WizardSuccess>
        </div>
    )
};

DeletePeriodicLoadSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    periodicLoadData: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired
};

module.exports = DeletePeriodicLoadSuccessStep;
